import { ref } from "vue";
import { R3VisualComponentBase } from "../../../../classes/base/R3VisualComponenteBase.classes";



export class R3LabelClass extends R3VisualComponentBase {
	// TODO analisar o que é necessário extender para o R3Label
	private _text = ref("");

	public get text(): string {
		return this._text.value;
	}

	public set text(value: string) {
		this._text.value = value;
	}


	constructor(params: {
		initialVisible?: boolean;
		initialText?: string;

	} = { initialText: "", initialVisible: true }) {

		super();
		this.text = params.initialText!;
		this.visible = params.initialVisible!;

	}
}